import { jsxs as e, jsx as l } from "react/jsx-runtime";

import { memo as a } from "react";

import s from "../../../utils/classNames/index.js";

const i = (a, i, r, t, m, n) => e(n ? "li" : "div", {
    className: "gap-xs inline-flex items-center",
    children: [ l("input", {
        ...t,
        disabled: i,
        id: a,
        className: s("flex-none", t.className)
    }), l("label", {
        ...m,
        className: s(m?.className, i ? "text-neutral-600" : ""),
        htmlFor: a,
        children: r
    }) ]
}), r = a((({id: e, label: l, disabled: a, labelProps: s, render: r = i, multiple: t, ...m}) => r(e, a, l, m, s, t)));

export { r as default };
//# sourceMappingURL=index.js.map
